/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon20Light = forwardRef('WarningTriangleIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.25 12.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" }),
        React.createElement("path", { d: "M10 6.11a.5.5 0 0 0-1 0V9.9a.5.5 0 0 0 1 0V6.11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.846 2.684a2 2 0 0 1 3.38 0l6.495 10.26c.843 1.331-.114 3.07-1.69 3.07H3.04c-1.576 0-2.533-1.739-1.69-3.07l6.495-10.26Zm2.535.535a1 1 0 0 0-1.69 0L2.196 13.48a1 1 0 0 0 .845 1.535h12.99a1 1 0 0 0 .845-1.535L10.38 3.219Z" })));
});
